// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.password.HpApiUserPasswordV3Handler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { HpApiUserPasswordV3Handler_update } from '@zg-rentals/ts-hotpads-api-client';

import type { HpApiResponseDto, HpUserPasswordUpdateRequestDto } from '@zg-rentals/ts-hotpads-api-client';

export interface HpApiUserPasswordV3Handler_update_Args {
  postData: HpUserPasswordUpdateRequestDto;
}

export type HpApiUserPasswordV3Handler_update_Options = UseMutationOptions<
  HpApiResponseDto<boolean>,
  unknown,
  HpApiUserPasswordV3Handler_update_Args
>;

/**
 * Update the signed-in user's password, authorized by the current password or a reset token
 */
export const useHpApiUserPasswordV3Handler_update = ({
  httpClient,
  ...options
}: Omit<HpApiUserPasswordV3Handler_update_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiUserPasswordV3Handler_update_Args) =>
      HpApiUserPasswordV3Handler_update(args.postData, httpClient),
  });
};
